module.exports = __webpack_public_path__ + "img/cross-black-background-grey.15856d66.svg";